import { SPECS_DESC_1, SPECS_DESC_2 } from "../helpers/content";
import volatility from "../assets/volatility.png";
import { GameConfigs } from "../../lib/globals/GameConfigs";

export default function Specs({ config, currency, coefs }) {
  return (
    <div className="wrapper">
      <div className="content">
        <div className="title">GAME SPECIFICATIONS</div>
        <div className="img_box small">
          <img src={volatility} alt="quest" />
        </div>
        <div className="description">{SPECS_DESC_1()}</div>
        <div>
          <span>
            Maximum Bet: {currency.length > 1 ? currency + " " : currency}
            {(+coefs[coefs.length - 1]).toLocaleString(undefined, {
              minimumFractionDigits: GameConfigs.config.currency_prec,
              maximumFractionDigits: GameConfigs.config.currency_prec,
            })}
          </span>{" "}
          <span>
            Minimum Bet: {currency.length > 1 ? currency + " " : currency}
            {(+coefs[0]).toLocaleString(undefined, {
              minimumFractionDigits: GameConfigs.config.currency_prec,
              maximumFractionDigits: GameConfigs.config.currency_prec,
            })}
          </span>
        </div>
        <div className="description">{SPECS_DESC_2(config.rtp)}</div>
      </div>
    </div>
  );
}
